import { FC, useEffect, useState } from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import {
  IReservationFormSchemaV2,
  IReservationV2
} from "../../../interfaces/reservations/Reservations.types";
import {
  paymentMethods,
  paymentStatus
} from "../../bundles/reservations/utils/PaymentsOptions";
import { TicketStatusEnum } from "../../reservations/res.enum";
import Input from "../../ui/input/Input";
import Select from "../../ui/select/Select";

const GeneralInfo: FC<{
  initialPaymentStatus: IReservationV2["paymentStatus"];
  reservationPrice?: number;
  clientNames?: IReservationV2["clientNames"];
}> = ({ initialPaymentStatus, reservationPrice, clientNames }) => {
  const { register, control, setValue } = useFormContext<IReservationFormSchemaV2>();
  const selectedPaymentStatus = useWatch({
    control,
    name: "paymentStatus"
  });
  const [showRefundAmount, setShowRefundAmount] = useState(false);

  useEffect(() => {
    if (initialPaymentStatus === TicketStatusEnum.Confirmed &&
        selectedPaymentStatus?.value === TicketStatusEnum.Canceled) {
      setShowRefundAmount(true);
      if (reservationPrice) {
        setValue("refundAmount", reservationPrice);
      }
    } else {
      setShowRefundAmount(false);
    }
  }, [selectedPaymentStatus, initialPaymentStatus, reservationPrice, setValue]);

  const filteredOptions = paymentStatus.filter((option) => {
    if (
      (initialPaymentStatus === TicketStatusEnum.Confirmed && (option.value === 1 || option.value === 3)) ||
      (initialPaymentStatus === TicketStatusEnum.Canceled && (option.value === 3 || option.value === 4))
    ) {
      return true;
    }
    return false;
  });

  return (
    <div className="border-t border-gray-200 py-6">
      <div className="px-5">
        <div className="flex justify-between gap-4">
          <Controller
            control={control}
            name="paymentMethod"
            render={({ field: { onChange, value } }) => (
              <Select
                label="Mënyra e pageses"
                selectedItem={value}
                options={paymentMethods}
                disabled
                onSelectedItemChange={(item) => onChange(item)}
              />
            )}
          />
          <Input label="Email" className="w-full" {...register("email")} />
          <Input label="Numri i telefonit" className="w-full" value={clientNames?.[0]?.phoneNumber || ""}
          disabled />
          <Controller
            control={control}
            name="paymentStatus"
            render={({ field: { onChange, value } }) => (
              <Select
                label="Statusi"
                selectedItem={value}
                disabled={initialPaymentStatus !== TicketStatusEnum.Confirmed &&
                  initialPaymentStatus !== TicketStatusEnum.Canceled}
                options={filteredOptions}
                onSelectedItemChange={(item) => onChange(item)}
              />
            )}
          />
        </div>
        {showRefundAmount && (
          <div className="flex justify-end mt-4">
            <div className="w-1/4">
              <Input
                label="Shuma per rimbursim"
                className="w-full"
                type="number"
                step="0.01"
                {...register("refundAmount")}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GeneralInfo;
